import { IndicatorsDataService } from './shared/indicators-data.service';
import {
  Component,
  OnInit,
  ViewChild,
  TemplateRef,
  ViewEncapsulation,
  OnDestroy
} from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { FormGroup, FormControl, Validators, FormBuilder, FormArray } from '@angular/forms';
import {
    CategoriaIndicador,
    Indicador
} from '@app/shared';
import {  find } from 'lodash';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { FlowService } from '@app/flow/shared/flow.service';
import { DatePipe } from "@angular/common";


// const log = new Logger('ReportsComponent');

@Component({
  selector: 'iw-indicators',
  templateUrl: './indicators.component.html',
  styleUrls: ['./indicators.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [FlowService, IndicatorsDataService, DatePipe],

})
export class IndicatorsComponent implements OnInit, OnDestroy {
  // define cuando mostrar el texto de ayuda de el rango de fechas
  textInfo = false;
  // Define cuando esta cargando
  isLoading = false;
  // Contiene la lista de categorias de reportes
  categoryIndicator: Array<CategoriaIndicador> = [];
  // Contiene la lista de reportes dinamicos
  indicators: Array<Indicador> = [];
  // Referencia de la modal
  modalRef: BsModalRef;
  // Contiene los templates de los controles personalizados
  templates = {};
  // Referencia al template de la modal
  @ViewChild('templateD') private templateD: TemplateRef<any>;
  // Referencia al template de la modal de modificacion de documento a generar
  @ViewChild('templateViewIndicator') private templateIndicatorView: TemplateRef<any>;
  // Referencia de el selector personalizado para los formularios
  @ViewChild('ngSelect') ngSelectTpl: TemplateRef<any>;
  // Formulario reportes dinamicos
  formRDynamic: FormGroup = new FormGroup({
    categoryIndicatorDynamic: new FormControl(null, [Validators.required]),
    indicatorDynamic: new FormControl(null, [Validators.required]),
  });
  // Destruye y gestiona el memory leak
  private destroy: Subject<void> = new Subject<void>();

  // controla si mostrar o no el mensaje deParámetros de búsqueda
  searchFilters: boolean = false;

  constructor(private modalService: BsModalService,
    private rds: IndicatorsDataService,
    private toastr: ToastrService,
    private fb: FormBuilder,
    private fs: FlowService
  ) { }

  ngOnInit() {
    this.templates = {
      ngSelectTpl: this.ngSelectTpl,
    };
  }

  ngOnDestroy() {
    this.destroy.next();
    this.destroy.complete();
  }



  /**
   * Abre la modal con el formulario correspondiente
   *
   * @memberof IndicatorsComponent
   */
  open() {
    this.rds.getCategoryIndicator().subscribe(data => {
        this.categoryIndicator = data;
      });

      this.formRDynamic.controls['categoryIndicatorDynamic'].valueChanges.subscribe(data => {
        if (data) {
          this.rds.getIndicatorsCategory(data).subscribe(indicador => {
            this.indicators = indicador;
          });
        } else {
          this.indicators = [];
        }
        this.formRDynamic.controls['indicatorDynamic'].reset();
      });
      this.modalRef = this.modalService.show(this.templateD, { class: 'modal-personalized', backdrop: 'static', keyboard: false });
  }

  /**
   * Con la acción de swicthear el selector de reporte limpia el formulario
  */
  changeSelectedIndicator(){
   
  }
  

  /**
   * Genera el reporte y lo descarga de la ruta recibida
   *
   * @param {String} [type='trazabilidad']
   * @memberof IndicatorsComponent
   */
  async SendDTP() {
    if(this.formRDynamic.controls['indicatorDynamic'].value){
        this.modalRef.hide();
        let indicatorResult = find(this.indicators,{id:this.formRDynamic.controls['indicatorDynamic'].value});
        this.modalRef = this.modalService.show(this.templateIndicatorView, { class:  'modal-personalized'});
        let document = {"ruta": indicatorResult.url, "nombre": indicatorResult.nombre} 
        this.modalRef.content = document;
    }
    this.isLoading = false;
  }

  // Metodo para limpiar los controles al cerrar la modal
  clear(): void {
    this.formRDynamic.reset();
    this.formRDynamic = new FormGroup({
        categoryIndicatorDynamic: new FormControl(null, [Validators.required]),
        indicatorDynamic: new FormControl(null, [Validators.required]),
    });
  }
  

closeModal() {
    this.modalRef.hide();
    this.modalRef = this.modalService.show(this.templateD, { class: 'modal-personalized', backdrop: 'static', keyboard: false });
}
}


// WEBPACK FOOTER //
// ./src/app/indicators/indicators.component.ts